import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Actions } from '@webapp/account/src/resources/alert';
import { selectShowBlocked } from '@webapp/account/src/resources/alert/selectors';
import { AccountRoutes } from '@webapp/account/src/resources/routes';

import { Modal } from '@webapp/common/components/modal';
import { useActions } from '@webapp/common/hooks/use-actions';

import css from './layout.css';

export const BlockedServicePopup: FC = () => {
    const visible = useSelector(selectShowBlocked);
    const hideBlocked = useActions(Actions.hideBlocked);

    const close = useCallback(() => hideBlocked(), [hideBlocked]);

    const accept = useCallback(() => {
        close();
        AccountRoutes.ordersLicence.go();
    }, [close]);

    return (
        <Modal
            acceptText='Оформить лицензию'
            className={css.blockedPopup}
            title='Внимание!'
            visible={visible}
            onAccept={accept}
            onCancel={close}
            onClose={close}
        >
            <div>Для работы с сервисом вам необходимо оплатить лицензию.</div>
        </Modal>
    );
};
